/**
 * Created by vtbelo on 01.04.2021
 */

UnitsShop.PRODUCTS = {};

UnitsShop.PRODUCTS[ShopWindow.TABS.UNITS_FRUIT] = {
    refreshTimeout: "270 minutes",
    refreshPrice: 29,

    default: [{
        unit: {
            code: "sacks",
            stage: 2,
            amount: 1
        },
        price: 150,
        type: Product.TYPE_SOFT,
        left: 3
    }],

    fruit_template: [{
        unit: {
            stage: 4,
            amount: 5
        },
        price: 75,
        type: Product.TYPE_SOFT,
        left: 3
    }, {
        unit: {
            stage: 4,
            amount: 10
        },
        price: 25,
        type: Product.TYPE_HARD,
        left: 3
    }]
};

UnitsShop.PRODUCTS[ShopWindow.TABS.UNITS_RESOURCE] = {
    refreshTimeout: "5 hours",
    refreshPrice: 49,

    default: [{
        unit: {
            type: "resourcechest",
            stage: 1,
            amount: 1
        },
        price: 135,
        type: Product.TYPE_SOFT,
        left: 2
    }, {
        unit: {
            type: "resourcechest",
            stage: 2,
            amount: 1
        },
        price: 75,
        type: Product.TYPE_HARD,
        left: 2
    }],

    resource_data: {
        default: {
            basicPrice: 50,
            stages: 6
        },
        wood: {
            basicPrice: 25,
            stages: 4
        },
        stone: {
            basicPrice: 30,
            stages: 5
        },
        wagon: {
            basicPrice: 35,
            stages: 5
        }
    },

    resource_template: {
        unit: {
            amount: 1
        },
        type: Product.TYPE_SOFT,
        left: 5
    }
};

UnitsShop.PRODUCTS[ShopWindow.TABS.UNITS_DISCOUNT] = {
    refreshTimeout: "6 hours",
    refreshPrice: 99,

    default: [{
        unit: [{
            code: "freechest",
            stage: 0,
            amount: 1
        }, {
            code: "sacks",
            stage: 0,
            amount: 1
        }, {
            type: "resourcechest",
            stage: 0,
            amount: 1
        }],
        type: Product.TYPE_FREE,
        videoBonus: true,
        left: 1
    },
    {
        unit: {
            code: "herochest",
            stage: 0,
            amount: 1
        },
        price: 55,
        type: Product.TYPE_SOFT,
        left: 2
    }, {
        unit: {
            code: "herochest",
            stage: 1,
            amount: 1
        },
        price: 35,
        type: Product.TYPE_HARD,
        left: 2
    }, {
        unit: {
            code: "herochest",
            stage: 2,
            amount: 1
        },
        price: 95,
        type: Product.TYPE_HARD,
        left: 2
    }, {
        unit: {
            code: "crystal",
            stage: 0,
            amount: 1
        },
        price: 75,
        type: Product.TYPE_SOFT,
        left: 1
    }, {
        unit: {
            code: "crystal",
            stage: 3,
            amount: 1
        },
        price: 195,
        type: Product.TYPE_HARD,
        left: 1
    }, {
        unit: {
            code: "worker",
            stage: 4,
            amount: 2
        },
        price: 150,
        type: Product.TYPE_HARD,
        left: 2
    }],

    hero_template: [{
        unit: {
            stage: 1,
            amount: 1
        },
        price: 25,
        type: Product.TYPE_HARD,
        left: 3
    }, {
        unit: {
            stage: 0,
            amount: 1
        },
        price: 35,
        type: Product.TYPE_SOFT,
        left: 3
    }]
};

UnitsShop.PRODUCTS[ShopWindow.TABS.UNITS_ADS_VIP] = {
    refreshTimeout: "24 hours",
    refreshPrice: 299,

    default: [{
        unit: {
            code: "wands",
            stage: 0,
            amount: 1
        },
        type: Product.TYPE_FREE,
        groupId: 1,
        left: 1
    }, {
        unit: {
            code: "worker",
            stage: 1,
            amount: 1
        },
        groupId: 2,
        type: Product.TYPE_ADS,
        price: 1,
        left: 1
    }, {
        unit: {
            code: "crystal",
            stage: 0,
            amount: 1
        },
        groupId: 2,
        type: Product.TYPE_ADS,
        price: 1,
        left: 1
    }, {
        unit: {
            type: "fruit",
            stage: 4,
            amount: 2
        },
        type: Product.TYPE_FREE,
        groupId: 1,
        left: 1
    }, {
        unit: {
            type: "resourcechest",
            stage: 0,
            amount: 1
        },
        groupId: 3,
        type: Product.TYPE_ADS,
        price: 1,
        left: 1
    }]
};

UnitsShop.PRODUCTS[ShopWindow.TABS.UNITS_ADS] = {
    refreshTimeout: "12 hours",
    refreshPrice: 299,

    default: [{
        unit: {
            code: "wands",
            stage: 0,
            amount: 1
        },
        groupId: 1,
        type: Product.TYPE_ADS,
        price: 5,
        left: 1
    }, {
        unit: {
            code: "herochest",
            stage: 0,
            amount: 1
        },
        groupId: 2,
        type: Product.TYPE_ADS,
        price: 10,
        left: 1
    }, {
        unit: {
            code: "sacks",
            stage: 2,
            amount: 1
        },
        groupId: 3,
        type: Product.TYPE_ADS,
        price: 20,
        left: 1
    }, {
        unit: {
            code: "coinscup",
            stage: 2,
            amount: 1
        },
        groupId: 3,
        type: Product.TYPE_ADS,
        price: 20,
        left: 1
    }, {
        unit: {
            code: "worker",
            stage: 3,
            amount: 2
        },
        groupId: 4,
        type: Product.TYPE_ADS,
        price: 25,
        left: 1
    }, {
        unit: {
            code: "worker",
            stage: 4,
            amount: 1
        },
        groupId: 4,
        type: Product.TYPE_ADS,
        price: 35,
        left: 1
    }, {
        unit: {
            code: "energycup",
            stage: 1,
            amount: 1
        },
        groupId: 4,
        type: Product.TYPE_ADS,
        price: 35,
        left: 1
    }, {
        unit: {
            code: "herochest",
            stage: 2,
            amount: 1
        },
        groupId: 5,
        type: Product.TYPE_ADS,
        price: 40,
        left: 1
    }, {
        unit: {
            code: "crystal",
            stage: 2,
            amount: 2
        },
        groupId: 5,
        type: Product.TYPE_ADS,
        price: 50,
        left: 1
    }, {
        unit: {
            code: "crystal",
            stage: 3,
            amount: 1
        },
        groupId: 5,
        type: Product.TYPE_ADS,
        price: 60,
        left: 1
    }, {
        unit: {
            type: "fruit",
            stage: 4,
            amount: 5
        },
        groupId: 2,
        type: Product.TYPE_ADS,
        price: 10,
        left: 1
    }, {
        unit: {
            type: "fruit",
            stage: 3,
            amount: 1
        },
        groupId: 2,
        type: Product.TYPE_ADS,
        price: 15,
        left: 1
    }, {
        unit: {
            type: "resourcechest",
            stage: 2,
            amount: 1
        },
        groupId: 3,
        type: Product.TYPE_ADS,
        price: 20,
        left: 1
    }]
};
